import React from "react";
import { hexToRgba } from "../../core/color";

function getGlowAlpha() {
  const cssValue = getComputedStyle(document.documentElement).getPropertyValue("--ecliptica-glow-alpha");
  const parsed = Number.parseFloat(cssValue);
  return Number.isFinite(parsed) ? parsed : 0.85;
}

export default function GoldText({ children, accent }) {
  return (
    <span style={{ color: accent, textShadow: `0 0 40px ${hexToRgba(accent, getGlowAlpha() * 0.8)}` }}>{children}</span>
  );
}
